import React, {useState} from 'react';

function SignUpMainForm({ onSignUpSubmit }) {
    const [formData, setFormData] = useState({ name: '', surname: '', nickname: '', email: '', password: '', verifyPassword: ''});

    const handleSubmit = (e) => {
        e.preventDefault();
        const { name, surname, nickname, email, password, verifyPassword } = formData;
        if (verifyPassword !== password) {alert("Verifica Password Errata"); return false}

        onSignUpSubmit({ name, surname, nickname, email, password });
    };

    return (
        <form className="space-y-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col gap-2">
                    <label className="text-white/70 text-sm font-medium">Name</label>

                    <div className="relative">
                        <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-white/40 text-lg">person</span>
                        <input onChange={e => setFormData({...formData, name: e.target.value})} className="input-glow w-full rounded-lg border border-[#324d67] bg-[#192633] text-white py-3 pl-12 pr-4 focus:outline-0 focus:ring-0 focus:border-primary transition-all placeholder:text-white/20" placeholder="e.g. Mario" type="text"/>
                    </div>
                </div>

                <div className="flex flex-col gap-2">
                    <label className="text-white/70 text-sm font-medium">Surname</label>

                    <div className="relative">
                        <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-white/40 text-lg">person</span>
                        <input onChange={e => setFormData({...formData, surname: e.target.value})} className="input-glow w-full rounded-lg border border-[#324d67] bg-[#192633] text-white py-3 pl-12 pr-4 focus:outline-0 focus:ring-0 focus:border-primary transition-all placeholder:text-white/20" placeholder="e.g Rossi" type="text"/>
                    </div>
                </div>
            </div>

            <div className="flex flex-col gap-2">
                <label className="text-white/70 text-sm font-medium">Nickname</label>

                <div className="relative">
                    <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-white/40 text-lg">person</span>
                    <input onChange={e => setFormData({...formData, nickname: e.target.value})} className="input-glow w-full rounded-lg border border-[#324d67] bg-[#192633] text-white py-3 pl-12 pr-4 focus:outline-0 focus:ring-0 focus:border-primary transition-all placeholder:text-white/20" placeholder="e.g. MaxVerstappen_1" type="text"/>
                </div>
            </div>

            <div className="flex flex-col gap-2">
                <label className="text-white/70 text-sm font-medium">Email Address</label>

                <div className="relative">
                    <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-white/40 text-lg">mail</span>
                    <input onChange={e => setFormData({...formData, email: e.target.value})} className="input-glow w-full rounded-lg border border-[#324d67] bg-[#192633] text-white py-3 pl-12 pr-4 focus:outline-0 focus:ring-0 focus:border-primary transition-all placeholder:text-white/20" placeholder="driver@example.com" type="email"/>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col gap-2">
                    <label className="text-white/70 text-sm font-medium">Password</label>

                    <div className="relative">
                        <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-white/40 text-lg">lock</span>
                        <input onChange={e => setFormData({...formData, password: e.target.value})} className="input-glow w-full rounded-lg border border-[#324d67] bg-[#192633] text-white py-3 pl-12 pr-4 focus:outline-0 focus:ring-0 focus:border-primary transition-all placeholder:text-white/20" placeholder="••••••••" type="password"/>
                    </div>
                </div>

                <div className="flex flex-col gap-2">
                    <label className="text-white/70 text-sm font-medium">Confirm</label>

                    <div className="relative">
                        <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-white/40 text-lg">shield_lock</span>
                        <input onChange={e => setFormData({...formData, verifyPassword: e.target.value})} className="input-glow w-full rounded-lg border border-[#324d67] bg-[#192633] text-white py-3 pl-12 pr-4 focus:outline-0 focus:ring-0 focus:border-primary transition-all placeholder:text-white/20" placeholder="••••••••" type="password"/>
                    </div>
                </div>
            </div>

            <div className="pt-4">
                <button onClick={handleSubmit} className="w-full bg-primary hover:bg-primary/80 text-white font-bold py-4 rounded-lg shadow-lg shadow-primary/20 transition-all flex items-center justify-center gap-2 group" type="submit">Register &amp; Join Pit Wall<span className="material-symbols-outlined group-hover:translate-x-1 transition-transform">sports_score</span></button>
            </div>
        </form>
    );
}

export default SignUpMainForm;